import { createSelector } from 'reselect'
import RootState from '../types'
import State from './types'

const getWishlistState = (state: RootState): State => state.wishlist

export const getWishlistCount = createSelector(
    getWishlistState,
    (wishlist: State): number | undefined => wishlist.count,
)

export const getGuestFavoriteListings = createSelector(
    getWishlistState,
    (wishlist: State): string[] => wishlist.guestFavoriteListings,
)
